/**
 * The Algu transformer logic is non-standard and would not be followed in a new implementation.
 *
 * TODO: If there is ever a Phase 2, replace all the transformers with "data driven" auto-fix
 *  - selecting the closest available combination of options from a table.
 */
export const ALL_VIOLATIONS = [
  'topShapeNotSupported',
  'fenixTopWithoutVariant',
  'oakTopWithoutFinish',
  'roundEdgeFinishNotSupported',
  'thicknessNotAvailableForThisMaterial',
  'topColorNotAvailableForThisMaterial',
  'topFinishNotAvailableForThisMaterial',
  'diameterNotAvailableForThisMaterial',
  'topMaterialNotSupported',
] as const
